import { Close, Save } from "@mui/icons-material";
import { IconButton, Stack, TextField} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import Toggle from "../../Inputs/Toggle"
import { txt } from "../../../services/translation";

export default function ChoiceForm({choice, onSubmit, onCancel}){

    const [data, setData] = useState(null)

    useEffect(() => {

        setData({...choice})

    }, [choice])

    const handleSubmit = e => {
        e.preventDefault()
        return onSubmit(data)
    }

    const sx = {
        margin: 'auto', 
        p: 1,
        maxWidth: 500
    }
    
    return data && <form onSubmit={handleSubmit}>

        <Stack spacing={2} sx={sx}>

                <Stack direction='row' justifyContent='flex-end'>
                    <IconButton size='small' color='primary' type='submit'>
                        <Save/>
                    </IconButton>

                    <IconButton size='small' color='error' onClick={onCancel}>
                        <Close/>
                    </IconButton>
                </Stack>

                <TextField 
                    label={txt('explanationLabel')}
                    value={data.explanation || ''}
                    onChange={e => setData({...data, explanation: e.target.value.substring(0, 500)})}
                    inputProps={{maxLength: 500}}
                    multiline
                    minRows={3}
                />

                <Toggle 
                    label={txt('correctToggleLabel')}
                    value={data.correct}
                    onChange={(e,v) => setData({...data, correct: v})}
                />

        </Stack>

    </form>
}